<template>
    <vs-input :type="params.filterParams.inputType" :value="value" @change="onChange" class="agGridFloatingFilter"></vs-input>
</template>

<script>
    import Vue from "vue";

    export default Vue.extend({
        name: "AgFloatingFilterComponent",
        data(){
            return {
                value: null,
                timeout: null,
                type: null,
            }
        },
        mounted() {
            this.type = this.params.filterParams.defaultType;
        },
        methods: {
            onChange(event) {
                this.value = event.target.value;
                let filterInstance = this.params.api.getFilterInstance(this.params.column.colDef.field);
                let filterModel = {
                    type: this.type,
                    value: event.target.value,
                };
                filterInstance.setModel(filterModel);
                this.params.frameworkComponentWrapper.parent.$parent.filterModified();
            },
            onParentModelChanged(parentModel) {
                this.value = !parentModel ? null : parentModel.value;
                this.type = !parentModel ? null : parentModel.type;
            },
        }
    })
</script>

<style lang="scss">


</style>